import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals 
{
    
    // aws devlopment url
    // readonly baseAppUrl: string = 'https://devtrack.shadowpin.com';
    // readonly baseAPIUrl: string = 'https://devtrack.shadowpin.com/ShadowpinAPIDev/api/';

    //aws production url
    
    readonly baseAppUrl: string = 'https://track.shadowpin.com';
    readonly baseAPIUrl: string = 'https://track.shadowpin.com/ShadowpinAPI/api/';


    //local environment url
    // readonly baseAppUrl: string = 'http://192.168.1.175:4200';
    // readonly baseAPIUrl: string = 'http://192.168.1.175:8888/api/';
    
    readonly clickATelAPIKey: string = 'Ep5duhP9RcWTXLyjVRSfyw==';
    readonly clickATelServiceProviderNo: Number = 18563002334;

    readonly LocateNowCommand: string = '%2BXT%3A7001%2C1';
    readonly IgnitionOnCommand: string = '%2BXT%3A7005%2C1%2C1';
    readonly IgnitionOffCommand: string = '%2BXT%3A7005%2C2%2C1';
    
    public IsMow: string = 'false';
    public MowToken: string = 'ABCXYZ';
    
    // LoggedIn user details
    GetLoggedUserDetail():any
    {
         return JSON.parse(localStorage.getItem('loginUser'));
    }
    
    public loginUser = JSON.parse(localStorage.getItem('loginUser'));

    public IsLoading = false;
}



// WEBPACK FOOTER //
// ./src/app/service/app.global.ts